<!--<template>-->
<!--    <div class="mx-auto">-->
<!--        &lt;!&ndash; danger message &ndash;&gt;-->
<!--        <div-->
<!--            class="flex items-center gap-x-4 bg-white border border-orange-300 text-sm text-gray-700 p-4 rounded-lg mb-8">-->
<!--            <div>-->
<!--                <component :is="Info" class="w-5 h-5 text-primary"/>-->
<!--            </div>-->
<!--            <p>-->
<!--                The Bison Account exchange rates shown and the corresponding counter value in the currency chosen are-->
<!--                merely indicative. The exchange rates fluctuate and may be different at the date/time the values are-->
<!--                converted. Bison Account will execute your order within 48 to 72 hours, counted in business days. Bison-->
<!--                Bank reserves the right to cancel your order in case of extraordinary conditions in the foreign exchange-->
<!--                market. For amounts above € 2 million, or equivalent, Bison Account reserves the right to confirm the-->
<!--                transaction trough the commercial area of the Bank, before execution.-->
<!--            </p>-->
<!--        </div>-->

<!--        &lt;!&ndash; Steps &ndash;&gt;-->
<!--        <div class="flex md:flex-row md:justify-between md:items-center md:border-b md:border-gray-200 mb-8 flex-col items-start gap-5">-->
<!--            <div class="w-fit bg-gray-100 transform translate-y-1/2 px-2 flex items-center justify-center relative">-->
<!--                <div-->
<!--                    :class="['w-8 h-8 flex items-center justify-center rounded-full font-bold z-10', activeStep === 1 ? 'bg-gray-800 text-white': 'bg-gray-200 text-gray-700']">-->
<!--                    1-->
<!--                </div>-->
<!--                <span-->
<!--                    :class="['ml-2 text-gray-500', { 'font-medium text-gray-900': activeStep === 1 }]">Fill Data</span>-->
<!--                &lt;!&ndash;                <div class="absolute top-4 left-0 right-0 h-0.5 bg-gray-200 z-0"></div>&ndash;&gt;-->
<!--            </div>-->

<!--            <div class="w-fit bg-gray-100 transform translate-y-1/2 px-2 flex items-center justify-center relative">-->
<!--                <div-->
<!--                    :class="['w-8 h-8 flex items-center justify-center rounded-full z-10', activeStep === 2 ? 'bg-gray-800 text-white': 'bg-gray-200 text-gray-700']">-->
<!--                    2-->
<!--                </div>-->
<!--                <span :class="['ml-2 text-gray-500', { 'font-medium text-gray-900': activeStep === 2 }]">Check the Operation</span>-->
<!--            </div>-->

<!--            <div class="w-fit bg-gray-100 transform translate-y-1/2 px-2 flex items-center justify-center relative">-->
<!--                <div-->
<!--                    :class="['w-8 h-8 flex items-center justify-center bg-gray-200 text-gray-700 rounded-full z-10', activeStep === 3 ? 'bg-gray-800 text-white': 'bg-gray-200 text-gray-700']">-->
<!--                    3-->
<!--                </div>-->
<!--                <span-->
<!--                    :class="['ml-2 text-gray-500', { 'font-medium text-gray-900': activeStep === 3 }]">Confirmation</span>-->
<!--            </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; Form &ndash;&gt;-->
<!--        <form class="space-y-8" @submit.prevent="handleSubmit">-->
<!--            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">-->
<!--                &lt;!&ndash; TO WHOM &ndash;&gt;-->
<!--                <div>-->
<!--                    <h3 class="font-semibold text-gray-800 mb-4">ACCOUNT TO CREDIT</h3>-->
<!--                    <div class="space-y-4">-->
<!--                        <div class="relative">-->
<!--                          <select-->
<!--                              v-model="selectedDestinationAccount"-->
<!--                              class="w-full px-4 py-3 pr-10 text-gray-600 bg-white border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"-->
<!--                          >-->
<!--                            <option value="" disabled class="text-gray-400">-->
<!--                              Account To Credit *-->
<!--                            </option>-->
<!--                            <option-->
<!--                                v-for="acc in availableAccounts"-->
<!--                                :key="acc.id"-->
<!--                                :value="acc"-->
<!--                            >-->
<!--                            {{ acc.account_name }} - {{ acc.account_number }} ({{ acc.currency }})-->
<!--                            </option>-->
<!--                          </select>-->


<!--                          <div class="absolute top-1/2 transform -translate-y-1/2 right-0 flex items-center pr-3 pointer-events-none">-->
<!--                                <component :is="ChevronDown" class="w-5 h-5 text-gray-400"/>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div>-->
<!--                            <input-->
<!--                                v-model="form.reference"-->
<!--                                class="w-full border border-gray-300 text-sm rounded-md px-3 py-3 focus:ring-2 focus:ring-orange-500 focus:outline-none"-->
<!--                                placeholder="Reference *"-->
<!--                                required-->
<!--                                type="text"-->
<!--                                disabled-->
<!--                            />-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

<!--                &lt;!&ndash; HOW MUCH &ndash;&gt;-->
<!--                <div>-->
<!--                    <h3 class="font-semibold text-gray-800 mb-4">HOW MUCH?</h3>-->
<!--                    <div class="space-y-4">-->
<!--                        <div class="flex items-center gap-x-2 relative">-->
<!--                            <input-->
<!--                                v-model="form.value"-->
<!--                                :min="0"-->
<!--                                :max="selectedAccount ? selectedAccount.available_balance : Infinity"-->
<!--                                class="w-full border border-gray-300 rounded-md px-3 py-3 focus:ring-2 focus:ring-orange-500 focus:outline-none"-->
<!--                                placeholder="Value *"-->
<!--                                required-->
<!--                                type="number"-->
<!--                            />-->
<!--                            <button class="text-gray-600 bg-gray-200 rounded px-3 py-3">EUR</button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; pay button &ndash;&gt;-->
<!--          <div class="flex justify-center">-->
<!--            <button-->
<!--                class="w-1/4 flex justify-center px-2 py-3 bg-primary text-white font-semibold rounded-lg shadow"-->
<!--                type="submit"-->
<!--                :disabled="loading"-->
<!--            >-->
<!--              {{ loading ? 'Processing...' : 'SEND' }}-->
<!--            </button>-->
<!--          </div>-->
<!--        </form>-->
<!--    </div>-->
<!--</template>-->

<!--<script setup>-->

<!--import { reactive, ref, watch, defineEmits, defineProps,computed } from 'vue';-->
<!--import { Info, ChevronDown } from 'lucide-vue-next';-->
<!--import api from '@/services/api'-->



<!--const props = defineProps({-->
<!--  accounts: {-->
<!--    type: Array,-->
<!--    default: () => []-->
<!--  },-->
<!--  selectedAccount: {-->
<!--    type: Object,-->
<!--    default: null-->
<!--  }-->
<!--});-->


<!--// const selectedAccount = ref('')-->
<!--// حساب مقصد انتخاب شده-->
<!--const selectedDestinationAccount = ref(null);-->
<!--const loading = ref(false)-->


<!--watch(selectedDestinationAccount, (newAcc) => {-->
<!--  if (newAcc) {-->
<!--    form.reference = `Book Balance: ${newAcc.currency} ${newAcc.available_balance}`;-->
<!--    // emit('update:modelValue', newAcc); // ارسال به والد در صورت نیاز-->
<!--  } else {-->
<!--    form.reference = '';-->
<!--  }-->
<!--});-->

<!--defineEmits(['update:modelValue'])-->

<!--const form = reactive({-->
<!--    entity: '',-->
<!--    reference: 'Book Balance: USD 0.00',-->
<!--    value: '',-->
<!--    date: '',-->
<!--    file: null,-->
<!--})-->

<!--const activeStep = ref(1);-->

<!--watch(selectedDestinationAccount, (newAcc) => {-->
<!--  if (newAcc) {-->
<!--    form.reference = `Book Balance: ${newAcc.currency} ${newAcc.available_balance}`;-->
<!--  } else {-->
<!--    form.reference = '';-->
<!--  }-->
<!--});-->




<!--const availableAccounts = computed(() => {-->
<!--  if (!props.selectedAccount) return props.accounts;-->
<!--  return props.accounts.filter(acc => acc.id !== props.selectedAccount.id);-->
<!--});-->


<!--const handleSubmit = async () => {-->
<!--  if (!selectedDestinationAccount.value || !form.value) return-->

<!--  // مرحله Fill Data تکمیل شد-->
<!--  activeStep.value = 2-->
<!--  loading.value = true-->

<!--  try {-->
<!--    const response = await api.post('/exchange', {-->
<!--      from_account_id: props.selectedAccount.id,-->
<!--      to_account_id: selectedDestinationAccount.value.id,-->
<!--      amount: form.value,-->
<!--      exchange_rate: 1.0 // اینجا می‌تونی نرخ واقعی اضافه کنی-->
<!--    }, {-->
<!--      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }-->
<!--    })-->

<!--    console.log('Exchange response:', response.data)-->
<!--    activeStep.value = 2-->
<!--    alert('Exchange request submitted successfully!')-->
<!--  } catch (err) {-->
<!--    console.error(err)-->
<!--    alert(err.response?.data?.error || 'Error submitting exchange request')-->
<!--    activeStep.value = 1-->
<!--  } finally {-->
<!--    loading.value = false-->
<!--  }-->
<!--}-->


<!--</script>-->


<template>
  <div class="mx-auto">

    <!-- info box -->
    <div class="flex items-center gap-x-4 bg-white border border-orange-300 text-sm text-gray-700 p-4 rounded-lg mb-8">
      <component :is="Info" class="w-5 h-5 text-primary"/>
      <p>
        The Bison Account exchange rates shown and the corresponding counter value in the currency chosen are
        merely indicative. The exchange rates fluctuate and may be different at the date/time the values are
        converted. Bison Account will execute your order within 48 to 72 hours, counted in business days. Bison
        Bank reserves the right to cancel your order in case of extraordinary conditions in the foreign exchange
        market. For amounts above € 2 million, or equivalent, Bison Account reserves the right to confirm the
        transaction trough the commercial area of the Bank, before execution.
      </p>
    </div>


    <!-- steps -->
    <div class="flex md:flex-row md:justify-between md:items-center md:border-b md:border-gray-200 mb-8 flex-col gap-5">

      <div class="flex items-center">
        <div :class="stepClass(1)">1</div>
        <span class="ml-2">Fill Data</span>
      </div>

      <div class="flex items-center">
        <div :class="stepClass(2)">2</div>
        <span class="ml-2">Check Operation</span>
      </div>

      <div class="flex items-center">
        <div :class="stepClass(3)">3</div>
        <span class="ml-2">Confirmation</span>
      </div>

    </div>


    <!-- STEP 1 -->
    <form v-if="activeStep === 1" class="space-y-8" @submit.prevent="getQuote">

      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">

        <!-- account destination -->
        <div>
          <h3 class="font-semibold mb-4">ACCOUNT TO CREDIT</h3>

          <select v-model="selectedDestinationAccount"
                  class="w-full border rounded-md px-4 py-3">

            <option disabled value="">Account To Credit *</option>

            <option v-for="acc in availableAccounts"
                    :key="acc.id"
                    :value="acc">

              {{ acc.account_name }} - {{ acc.account_number }} ({{ acc.currency }})

            </option>

          </select>

        </div>


        <!-- amount -->
        <div>

          <h3 class="font-semibold mb-4">HOW MUCH?</h3>

          <div class="flex gap-2">

            <input
                v-model="form.value"
                type="number"
                required
                class="w-full border rounded-md px-3 py-3"
                placeholder="Amount"
            />

            <button class="bg-gray-200 px-3 rounded">
              {{ props.selectedAccount?.currency }}
            </button>

          </div>

        </div>

      </div>


      <div class="flex justify-center">

        <button
            class="w-1/4 py-3 bg-primary text-white rounded-lg"
            :disabled="loading">

          {{ loading ? 'Calculating...' : 'Continue' }}

        </button>

      </div>

    </form>



    <!-- STEP 2 -->
    <div v-if="activeStep === 2 && quote" class="bg-white border rounded-lg p-6">

      <h3 class="font-semibold text-lg mb-6">Exchange Details</h3>


      <div class="space-y-3 text-sm">

        <div class="flex justify-between">
          <span>You send</span>
          <span>{{ quote.amount }} {{ quote.from_currency }}</span>
        </div>

        <div class="flex justify-between">
          <span>Base Rate</span>
          <span>{{ quote.base_rate }}</span>
        </div>

        <div class="flex justify-between">
          <span>Spread</span>
          <span>{{ (quote.spread_percent * 100).toFixed(2) }}%</span>
        </div>

        <div class="flex justify-between font-medium">
          <span>Effective Rate</span>
          <span>{{ quote.effective_rate }}</span>
        </div>

        <div class="flex justify-between">
          <span>Bank Fee</span>
          <span>{{ quote.fee }} {{ quote.to_currency }}</span>
        </div>

        <div class="border-t pt-3 flex justify-between font-bold text-lg">
          <span>You Receive</span>
          <span>{{ quote.converted_amount_after_fee }} {{ quote.to_currency }}</span>
        </div>

      </div>


      <div class="flex justify-between mt-8">

        <button
            @click="activeStep = 1"
            class="px-6 py-3 border rounded">

          Back

        </button>

        <button
            @click="confirmExchange"
            class="px-6 py-3 bg-primary text-white rounded">

          Confirm Exchange

        </button>

      </div>

    </div>



    <!-- STEP 3 -->
    <div v-if="activeStep === 3" class="text-center py-10">

      <h3 class="text-xl font-semibold mb-4">
        Exchange Completed
      </h3>

      <p class="text-gray-600">
        Your FX transaction has been submitted successfully.
      </p>

    </div>

  </div>
</template>



<script setup>

import {ref, reactive, computed,defineProps} from "vue"
import {Info} from "lucide-vue-next"
import api from "@/services/api"


const props = defineProps({
  accounts: Array,
  selectedAccount: Object
})


const activeStep = ref(1)
const loading = ref(false)

const quote = ref(null)

const selectedDestinationAccount = ref("")


const form = reactive({
  value:""
})


const availableAccounts = computed(()=>{
  if(!props.selectedAccount) return props.accounts
  return props.accounts.filter(a=>a.id !== props.selectedAccount.id)
})


const stepClass = (step)=>{
  return [
    "w-8 h-8 flex items-center justify-center rounded-full font-bold",
    activeStep.value === step
        ? "bg-gray-800 text-white"
        : "bg-gray-200 text-gray-700"
  ]
}


const getQuote = async ()=>{

  if(!selectedDestinationAccount.value || !form.value) return

  loading.value = true

  try{

    const res = await api.post("/exchange/quote",{
      from_account_id: props.selectedAccount.id,
      to_account_id: selectedDestinationAccount.value.id,
      value: form.value
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })

    quote.value = res.data

    activeStep.value = 2

  }
  catch(err){

    alert(err.response?.data?.message || "Quote error")

  }
  finally{

    loading.value = false

  }

}



const confirmExchange = async ()=>{

  loading.value = true

  try{

    await api.post("/exchange",{
      from_account_id: props.selectedAccount.id,
      to_account_id: selectedDestinationAccount.value.id,
      amount: form.value
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })

    activeStep.value = 3

  }
  catch(err){

    alert(err.response?.data?.error || "Exchange failed")

  }
  finally{

    loading.value = false

  }

}

</script>